// extracted by mini-css-extract-plugin
module.exports = {"badge":"VerifiedBadge_badge__3sWcQ","container":"VerifiedBadge_container__3Efu5","icon":"VerifiedBadge_icon__1TtPx"};